/**
 * Outbound webhook event types a business endpoint can subscribe to.
 *
 * Values are stored in Webhooks.events and Webhook_Deliveries.event_type and appear in every
 * delivery envelope as `type`, so they must remain stable. `order.state_changed` is the superset of
 * the order lifecycle: an endpoint subscribed to it and to `order.submitted` receives two deliveries
 * for a submit. `workflow.fired` is only produced by the "send webhook" workflow step action and
 * by endpoint workflow triggers, never by a resource subscription.
 */
enum WebhookEventEnum {
    ORDER_CREATED = "order.created",
    ORDER_SUBMITTED = "order.submitted",
    ORDER_STATE_CHANGED = "order.state_changed",
    ORDER_DELETED = "order.deleted",
    QUOTE_CREATED = "quote.created",
    QUOTE_SENT = "quote.sent",
    QUOTE_CONVERTED_TO_ORDER = "quote.converted_to_order",
    SHIPMENT_CREATED = "shipment.created",
    SHIPMENT_VOIDED = "shipment.voided",
    SHIPMENT_DELETED = "shipment.deleted",
    CATALOG_ITEM_CREATED = "catalog_item.created",
    CATALOG_ITEM_UPDATED = "catalog_item.updated",
    CATALOG_ITEM_DELETED = "catalog_item.deleted",
    VENDOR_CREATED = "vendor.created",
    VENDOR_UPDATED = "vendor.updated",
    VENDOR_DELETED = "vendor.deleted",
    VENDOR_SOURCE_CREATED = "vendor_source.created",
    VENDOR_SOURCE_UPDATED = "vendor_source.updated",
    VENDOR_SOURCE_DELETED = "vendor_source.deleted",
    WORKFLOW_FIRED = "workflow.fired",
    /** Sent by the "send test" action only; carries a sample order payload. */
    TEST = "test",
}

export default WebhookEventEnum;
